import { FeatureMenuStateTypes, FeatureMenuActionTypes } from "./FeatureMenu.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: FeatureMenuStateTypes = {
  fetchAll: resetApiCallState([]),
  fetchOne: resetApiCallState({}),
};

const FeatureMenuReducer = (
  state: FeatureMenuStateTypes = INITIAL_STATE,
  action: any
): FeatureMenuStateTypes => {
  switch (action.type) {
    case FeatureMenuActionTypes.FETCH_ALL_FEATURE_MENU:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case FeatureMenuActionTypes.FETCH_ALL_FEATURE_MENU_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case FeatureMenuActionTypes.FETCH_ALL_FEATURE_MENU_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case FeatureMenuActionTypes.FETCH_ALL_FEATURE_MENU_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    case FeatureMenuActionTypes.FETCH_ONE_FEATURE_MENU:
      return {
        ...state,
        fetchOne: {
          error: null,
          payload: {},
          isPending: true,
          isSuccessful: false,
        },
      };
    case FeatureMenuActionTypes.FETCH_ONE_FEATURE_MENU_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case FeatureMenuActionTypes.FETCH_ONE_FEATURE_MENU_FAILURE:
      return {
        ...state,
        fetchOne: {
          payload: {},
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case FeatureMenuActionTypes.FETCH_ONE_FEATURE_MENU_SUCCESS:
      return {
        ...state,
        fetchOne: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default FeatureMenuReducer;
